import moment from 'moment';
import HelperMixin from '../../Shared/HelperMixin.vue';

// SOS-13 / UI-09 — Admin viewer of UsersTrustedContacts.
// The MobileApp side has CRUD for these (TrustedContactsController), but
// no admin read endpoint exists yet. The page hits a "would-be" route
// `GET api/admin/Users/{userId}/TrustedContacts` and surfaces a clear
// "missing endpoint" notice when it 404s, so Agent A1 (backend) sees the
// gap clearly.

export default {
    name: 'TrustedContacts',
    mixins: [HelperMixin],

    filters: {
        moment(date) {
            if (!date) return '—';
            return moment(date).format('DD/MM/YYYY');
        }
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.requireUserType([1])) return;
    },

    data() {
        return {
            Items: [],
            Filtered: [],
            Search: '',
            UserIdFilter: '',
            MissingEndpoint: false,
        };
    },

    methods: {
        async Load() {
            if (!this.UserIdFilter) {
                this.Items = [];
                this.Filter();
                return;
            }
            this.$blockUI.Start();
            this.MissingEndpoint = false;
            try {
                const res = await this.$http.GetUserTrustedContacts(this.UserIdFilter);
                this.Items = res.data || [];
                this.Filter();
            } catch (e) {
                const code = e?.response?.status;
                if (code === 404 || code === 405) {
                    this.MissingEndpoint = true;
                }
                this.Items = [];
                this.Filter();
            } finally {
                this.$blockUI.Stop();
            }
        },
        Filter() {
            const s = (this.Search || '').toLowerCase().trim();
            if (!s) { this.Filtered = this.Items; return; }
            this.Filtered = this.Items.filter(it =>
                (it.name && it.name.toLowerCase().includes(s)) ||
                (it.phone && it.phone.toLowerCase().includes(s)) ||
                (it.relation && it.relation.toLowerCase().includes(s))
            );
        }
    }
};
